import React from "react"
import capitalize from "lodash.capitalize"
import { NavLink } from "react-router-dom"

import ago from "@helpers/ago"


const getTableColumns = () => {
  const columns = [
    {
      key: "name",
      compute: ({ name }) => name,
      render: (name, { id }) =>
        <NavLink to={`/backstage/project/${id}/details`}>
          {name}
        </NavLink>,
      isSearchable: true,
    },
    {
      key: "type",
      compute: ({ type }) => capitalize(type),
      width: 180,
    },
    {
      key: "updatedAt",
      width: 180,
      render: value => ago(value),
    }
  ]

  return columns
}

export default getTableColumns
